/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SalesConfigPaymentOverviewResponse } from '../models/SalesConfigPaymentOverviewResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class SalesConfigPaymentOverviewService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns SalesConfigPaymentOverviewResponse
     * @throws ApiError
     */
    public getSalesConfigPaymentOverviewIndex(): CancelablePromise<SalesConfigPaymentOverviewResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/sales/config/payments',
        });
    }

}
